import { BrowserUtility, BrowserKinds } from "../../../utilities";

export class WindowFinder {
  static existsParentWindow(): boolean {
    switch (BrowserUtility.getBrowserKind()) {
      case BrowserKinds.InternetExplorer:
        return window.opener && !window.opener.closed;
      case BrowserKinds.GoogleChrome:
      case BrowserKinds.ChromiumEdge:
          return !!window.opener;
      default:
        return (window.opener && !window.opener.closed) || !!window.opener;
    }
  }
}
